// react
import { useContext, useState } from "react";
// libs
import styled from "styled-components";
import { motion } from "framer-motion";
// components
import { Box } from "../Box";
import { ImageFill } from "../ImageFill";
import { Text } from "../Text";
import { ArtifactViewSelectionContext } from "../../context/ArtifactViewSelectionContext";
import Tooltip from "../Tooltip";
// other
import { Artifact } from "../../models/client";
import { cursorIcon } from "../../helpers/transformers/interactive-slide";

interface ATOtherItemProps {
  object: Artifact;
}

const OtherItemImgCont = styled(motion.div)`
  position: relative;
  padding-top: 140%;
  box-shadow: 10px 20px 50px 10px rgb(139 125 130 / 50%);
  cursor: pointer;
`;

const OtherItemLabelHolder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: left top;
`;

const TooltipPosition = styled(motion.div)`
  position: absolute;
  bottom: 32px;
  left: 32px;
  z-index: 1;
`;

function ATOtherItem({ object }: ATOtherItemProps) {
  const [hovered, setHovered] = useState(false);
  const { setArtifactById } = useContext(ArtifactViewSelectionContext);

  const handleMouseOver = () => {
    if (!hovered) {
      setHovered(true);
    }
  };

  return (
    <Box position="relative" pl="2em">
      <OtherItemImgCont
        tabIndex={0}
        role="button"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 1 }}
        onClick={() => setArtifactById(object.id)}
        onMouseOver={handleMouseOver}
        onMouseLeave={() => setHovered(false)}
      >
        <ImageFill src={object.previewImg.src} fit={object.previewImg.fit} />

        <TooltipPosition>
          <Tooltip icon={cursorIcon(object.type)} expanded={hovered}>
            {object.helperText}
          </Tooltip>
        </TooltipPosition>
      </OtherItemImgCont>
      <OtherItemLabelHolder>
        <Text variant="small" as="span">
          {object.longName ? object.longName : object.name}
        </Text>
      </OtherItemLabelHolder>
    </Box>
  );
}

export default ATOtherItem;
